import { palette } from "@interia/common/styles/global"
import React from "react"
import { Timeline } from "types"
import TimelineRow from "./timelineRow"
import { Wrapper } from './timelines.style'


type Props = {
  timelines: Timeline[]
}

const Timelines = ({ timelines }: Props) => {


  return (
    <Wrapper>
      {timelines.map((timeline, key) => {
        return <TimelineRow lastElement={key == timelines.length - 1} key={key} image={timeline.timelineOptions.image} description={timeline.timelineOptions.description} />
      })}

    </Wrapper >
  )
}

export default Timelines
